import * as React from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import { useEffect, useState } from "react";
import axios from "axios";
import * as go from "gojs";
import { ReactDiagram, ReactPalette } from "gojs-react";
import { geoFunc, colorFunc } from "../../../../_components/GojsGeostrings";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import {nodeDataArray, pipePalletNodeDataArray} from "./FxFlowGojs_Constants";
import {AttrListEdit} from "../../../datas/OpClass";
import {FxmsData} from "../../../datas/FxData";
import {TextField} from "@mui/material";
import {canvas} from "leaflet/dist/leaflet-src.esm";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";

export const FxFlowGojs = (props) => {
    const [nodeData, setNodeData] = useState([]);
    const [linkData, setLinkData] = useState([]);
    const [mode, setMode] = useState(true);
    const [svgTemplate, setSvgTemplate] = useState();
    const [pictureTemplate, setPictureTemplate] = useState();
    const [data, setData] = useState(2);
    const [model, setModel] = useState();
    const [bgimg, setBgimg] = useState("none");
    const [modelEnable, setModelEnable] = useState(false)
    const [canvasHeight, setCanvasHeight] = useState(300)
    const [linkStrokeColor, setLinkStrokeColor] = useState('#fff1aa')
    const [linkWidth, setLinkWidth] = useState(7)
    const [linkLineColor, setLinkLineColor] = useState("#adadad")
    const [linkLineWidth, setLinkLineWidth] = useState(7)
    const [animation, setAnimation] = useState(null);
    const [palletType, setPalletType] = useState(['pipe','plant','sensor']);
    const [selectedPallet, setSelectedPallet] = useState('')
    const [pipeList, setPipeList] = useState([])
    const [selectedPipe, setSelectedPipe] = useState('')
    const onChange = (e) => {
        //setSave({nodeDataArray:e.model.nodeDataArray,linkDataArray:e.model.linkDataArray})
    };
    useEffect(() => {
        FxmsData.get('feFacPipe/list').then(list=>{
            setPipeList(list.data)
        })
        if(props.item.fxUiDashbItemAttrs.length > 0) {
            if(props.item.fxUiDashbItemAttrs.find(x => x.attrName == 'pipeId')){
                handlePipeChange({target:{value:props.item.fxUiDashbItemAttrs.find(x => x.attrName == 'pipeId').attrVal}})
            }
        }
        // axios.get('http://175.123.142.155:11880/getPipe').then(res=>{
        //     setPipeList(res.data)
        //     if(props.item.fxUiDashbItemAttrs){
        //         if(props.item.fxUiDashbItemAttrs.length > 0) {
        //             if(props.item.fxUiDashbItemAttrs.find(x => x.attrName == 'pipeId')){
        //                 let data = res.data.filter(x=>x._id == props.item.fxUiDashbItemAttrs.find(x => x.attrName == 'pipeId').attrVal)[0]
        //                 setBgimg(data.bgimg ? 'none':data.bgimg)
        //                 setCanvasHeight(data.canvasHeight)
        //                 setLinkStrokeColor(data.linkStrokeColor ? data.linkStrokeColor : "#000000")
        //                 setLinkWidth(data.linkWidth ?data.linkWidth : 10)
        //                 setLinkLineColor(data.linkLineColor ? data.linkLineColor : "#707070")
        //                 setLinkLineWidth(data.lineWidth ? data.lineWidth  : 10)
        //                 setNodeData(data.nodeDataArray ? data.nodeDataArray : [] )
        //                 setLinkData(data.linkDataArray ? data.linkDataArray : [])
        //                 setSelectedPipe(props.item.fxUiDashbItemAttrs.find(x => x.attrName == 'pipeId').attrVal)
        //             }
        //
        //         }
        //     }
        // })







    }, []);


    // const animateFlow = () => {
    //
    //     let down = true
    //     let opacity = 1
    //     setInterval(() => {
    //         if(model){
    //             console.log('run')
    //             let oldskips = model.skipsUndoManager;
    //             model.skipsUndoManager = true;
    //             model.links.each(link => {
    //                 let shape = link.findObject("PIPE");
    //                 let off = shape.strokeDashOffset - 3;
    //                 // animate (move) the stroke dash
    //                 shape.strokeDashOffset = (off <= 0) ? 60 : off;
    //                 // animte (strobe) the opacity:
    //                 // if (down) opacity = opacity - 0.01;
    //                 // else opacity = opacity + 0.003;
    //                 // if (opacity <= 0) { down = !down; opacity = 0; }
    //                 // if (opacity > 1) { down = !down; opacity = 1; }
    //                 shape.opacity = opacity;
    //             });
    //             model.skipsUndoManager = oldskips;
    //             //animateFlow();
    //         }
    //     }, 60);
    // }
    const makeButton = (text, action, visiblePredicate) =>{
        const $ = go.GraphObject.make;
        return $("ContextMenuButton",
            $(go.TextBlock, text),
            { click: action },
            // don't bother with binding GraphObject.visible if there's no predicate
            visiblePredicate ? new go.Binding("visible", "", (o, e) => o.diagram ? visiblePredicate(o, e) : false).ofObject() : {});
    }
    const createTemplates = () =>{
        const $ = go.GraphObject.make;
        let svgTemplate = $(
            go.Node,
            "Spot",
            {
                locationObjectName: "PORT",
                locationSpot: go.Spot.Top, // location point is the middle top of the PORT
                //linkConnected: updatePortHeight,
                //linkDisconnected: updatePortHeight,
                toolTip: $(
                    "ToolTip",
                    $(
                        go.TextBlock,
                        { margin: 4, width: 140 },
                        new go.Binding(
                            "text",
                            "",
                            (data) => data.text + ":\n\n" + data.description
                        )
                    )
                ),
            },
            new go.Binding("location", "pos", go.Point.parse).makeTwoWay(
                go.Point.stringify
            ),
            // The main element of the Spot panel is a vertical panel housing an optional icon,
            // plus a rectangle that acts as the port
            $(
                go.Panel,
                "Vertical",
                $(
                    go.TextBlock,
                    { name: "temp", text: "" },
                    new go.Binding("name", "key"),
                    new go.Binding("text", "value")
                ),

                $(
                    go.Shape,
                    {
                        width: 40,
                        height: 0,
                        stroke: "#fff7e3",
                        strokeWidth: 0.1,
                        fill: "#ffffff",
                    },
                    new go.Binding("height", "icon", () => 40),
                    new go.Binding("fill", "color", colorFunc),
                    new go.Binding("geometry", "icon", geoFunc)
                ),
                $(
                    go.Shape,
                    {
                        name: "PORT",
                        width: 40,
                        height: 12,
                        margin: new go.Margin(-1, 0, 0, 0),
                        stroke: "black",
                        strokeWidth: 1,
                        fill: "gray",
                        portId: "",
                        fromLinkable: true,
                        toLinkable: true,
                    },
                    new go.Binding("fill", "color", colorFunc)
                ),
                $(
                    go.TextBlock,
                    {
                        font: "Bold 14px Lato, sans-serif",
                        textAlign: "center",
                        margin: 3,
                        maxSize: new go.Size(100, NaN),
                        alignment: go.Spot.Top,
                        alignmentFocus: go.Spot.Bottom,
                        editable: true,
                        stroke: "white",
                    },
                    new go.Binding("text", "moNo").makeTwoWay()
                ),
                $(
                    go.TextBlock,
                    {
                        font: "Bold 14px Lato, sans-serif",
                        textAlign: "center",
                        margin: 3,
                        maxSize: new go.Size(100, NaN),
                        alignment: go.Spot.Top,
                        alignmentFocus: go.Spot.Bottom,
                        editable: true,
                        stroke: "white",
                    },
                    new go.Binding("text").makeTwoWay()
                )
            )
        );


        let pictureTemplate = $(
            go.Node,
            "Spot",
            { locationObjectName: "PORT", locationSpot: go.Spot.Bottom },
            new go.Binding("location", "pos", go.Point.parse).makeTwoWay(
                go.Point.stringify
            ),
            $(
                go.Panel,
                "Vertical",
                $(
                    go.TextBlock,
                    { name: "temp", text: "" },
                    new go.Binding("name", "key"),
                    new go.Binding("text", "value")
                ),
                $(
                    go.Picture,
                    {
                        source: "thingspire.png",
                        portId: "",
                        width: 40,
                        height: 40,
                        fromLinkable: true,
                        toLinkable: true,
                    },
                    new go.Binding("source", "icon"),
                    new go.Binding("width", "width"),
                    new go.Binding("height", "height")
                ),
                $(
                    go.TextBlock,
                    {
                        font: "Bold 14px Lato, sans-serif",
                        textAlign: "center",
                        margin: 3,
                        maxSize: new go.Size(100, NaN),
                        alignment: go.Spot.Top,
                        alignmentFocus: go.Spot.Bottom,
                        editable: true,
                        stroke: "white",
                    },
                    new go.Binding("text", "moNo").makeTwoWay()
                ),
                $(
                    go.TextBlock,
                    {
                        font: "Bold 14px Lato, sans-serif",
                        textAlign: "center",
                        margin: 3,
                        maxSize: new go.Size(100, NaN),
                        alignment: go.Spot.Top,
                        alignmentFocus: go.Spot.Bottom,
                        editable: true,
                        stroke: "white",
                    },
                    new go.Binding("text").makeTwoWay()
                )
            )
        );

        // Show different kinds of port fittings by using different shapes in this Binding converter
        const portFigure =(pid) =>{
            if (pid === null || pid === "") return "XLine";
            if (pid[0] === 'F') return "CircleLine";
            if (pid[0] === 'M') return "PlusLine";
            return "XLine";  // including when the first character is 'U'
        }
        // Change the angle of the parts connected with the given node
        const rotate = (node, angle) =>{
            const tool = model.toolManager.draggingTool;  // should be a SnappingTool
            model.startTransaction("rotate " + angle.toString());
            const sel = new go.Set(/*go.Node*/);
            sel.add(node);
            const coll = tool.computeEffectiveCollection(sel).toKeySet();
            const bounds = model.computePartsBounds(coll);
            const center = bounds.center;
            coll.each(n => {
                n.angle += angle;
                n.location = n.location.copy().subtract(center).rotate(angle).add(center);
            });
            model.commitTransaction("rotate " + angle.toString());
        }
        function detachSelection() {
            model.startTransaction("detach");
            const coll = new go.Set(/*go.Link*/);
            model.selection.each(node => {
                if (!(node instanceof go.Node)) return;
                node.linksConnected.each(link => {
                    if (link.category !== "") return;  // ignore comments
                    // ignore links to other selected nodes
                    if (link.getOtherNode(node).isSelected) return;
                    // disconnect this link
                    coll.add(link);
                });
            });
            model.removeParts(coll, false);
            model.commitTransaction("detach");
        }

        // To simplify this code we define a function for creating a context menu button:
        function makeButton(text, action, visiblePredicate) {
            return $("ContextMenuButton",
                $(go.TextBlock, text),
                { click: action },
                // don't bother with binding GraphObject.visible if there's no predicate
                visiblePredicate ? new go.Binding("visible", "", (o, e) => o.diagram ? visiblePredicate(o, e) : false).ofObject() : {});
        }
        let pipeTemplate = $(go.Node, "Spot",
            {
                locationObjectName: "SHAPE",
                locationSpot: go.Spot.Center,
                selectionAdorned: false,  // use a Binding on the Shape.stroke to show selection
                itemTemplate:
                // each port is an "X" shape whose alignment spot and port ID are given by the item data
                    $(go.Panel,
                        new go.Binding("portId", "id"),
                        new go.Binding("alignment", "spot", go.Spot.parse),
                        $(go.Shape, "XLine",
                            { width: 0, height: 0, background: "transparent", fill: null, stroke: "gray" },
                            new go.Binding("figure", "id", portFigure),  // portFigure converter is defined below
                            new go.Binding("angle", "angle"))
                    ),
                // hide a port when it is connected
                linkConnected: (node, link, port) => {
                    if (link.category === "") {
                        port.visible = true;
                        link.visible = false;
                    }
                },
                linkDisconnected: (node, link, port) => {
                    if (link.category === ""){
                        port.visible = true;
                        link.visible = false;
                    }
                }
            },
            // this creates the variable number of ports for this Spot Panel, based on the data
            new go.Binding("itemArray", "ports"),
            // remember the location of this Node
            new go.Binding("location", "loc", go.Point.parse).makeTwoWay(go.Point.stringify),
            // remember the angle of this Node
            new go.Binding("angle", "angle").makeTwoWay(),
            // move a selected part into the Foreground layer, so it isn't obscured by any non-selected parts
            new go.Binding("layerName", "isSelected", s => s ? "Foreground" : "").ofObject(),
            $(go.Shape,
                {
                    name: "SHAPE",
                    // the following are default values;
                    // actual values may come from the node data object via data binding
                    geometryString: "F1 M0 0 L20 0 20 20 0 20 z",
                    fill: "rgba(128, 128, 128, 0.5)"
                },
                // this determines the actual shape of the Shape
                new go.Binding("geometryString", "geo"),
                // selection causes the stroke to be blue instead of black
                new go.Binding("stroke", "isSelected", s => s ? "dodgerblue" : "black").ofObject())
        );



        pipeTemplate.contextMenu = $("ContextMenu",
            makeButton("Rotate +45",
                (e, obj) => rotate(obj.part.adornedPart, 45)),
            makeButton("Rotate -45",
                (e, obj) => rotate(obj.part.adornedPart, -45)),
            makeButton("Rotate 180",
                (e, obj) => rotate(obj.part.adornedPart, 180)),
            makeButton("Detach",
                (e, obj) => detachSelection()),
            makeButton("Cut",
                (e, obj) => e.diagram.commandHandler.cutSelection(),
                o => o.diagram.commandHandler.canCutSelection()),
            makeButton("Copy",
                (e, obj) => e.diagram.commandHandler.copySelection(),
                o => o.diagram.commandHandler.canCopySelection()),
            makeButton("Paste",
                (e, obj) => e.diagram.commandHandler.pasteSelection(e.diagram.toolManager.contextMenuTool.mouseDownPoint),
                o => o.diagram.commandHandler.canPasteSelection(o.diagram.toolManager.contextMenuTool.mouseDownPoint)),
            makeButton("Delete",
                (e, obj) => e.diagram.commandHandler.deleteSelection(),
                o => o.diagram.commandHandler.canDeleteSelection()),
            makeButton("Undo",
                (e, obj) => e.diagram.commandHandler.undo(),
                o => o.diagram.commandHandler.canUndo()),
            makeButton("Redo",
                (e, obj) => e.diagram.commandHandler.redo(),
                o => o.diagram.commandHandler.canRedo())
        );


        return {svgTemplate,pictureTemplate,pipeTemplate}
    }
    const initDiagram = () => {
        const $ = go.GraphObject.make; // for conciseness in defining templates
        const myDiagram = $(
            go.Diagram, // create a Diagram for the DIV HTML element
            {
                "grid.visible": true,
                "grid.gridCellSize": new go.Size(20, 20),
                allowZoom:true,
                initialAutoScale: go.Diagram.Uniform, // scale to show all of the contents
                //ChangedSelection: onSelectionChanged, // view additional information
                maxSelectionCount: 1, // don't allow users to select more than one thing at a time
                isReadOnly: false,
                isEnabled : false,
                "undoManager.isEnabled": true, // must be set to allow for model change listening
                // 'undoManager.maxHistoryLength': 0,  // uncomment disable undo/redo functionality
                //더블클릭시 신규노드가 생성되는 기능
                //'clickCreatingTool.archetypeNodeData': { text: 'new node', color: 'lightblue' },
                //"grid.gridCellSize": new go.Size(30, 20),
                //"draggingTool.isGridSnapEnabled": true,
                "resizingTool.isGridSnapEnabled": true,
                "rotatingTool.snapAngleMultiple": 90,
                "rotatingTool.snapAngleEpsilon": 45,
                model: new go.GraphLinksModel({
                    linkKeyProperty: "key", // IMPORTANT! must be defined for merges and data sync when using GraphLinksModel
                }),
                "ModelChanged": e => {
                    if (e.isTransactionFinished) {handleModelChange() };

                },
                //pipeline 용 속성들
                draggingTool: new SnappingTool(),
                contextMenu:
                    $("ContextMenu",
                        makeButton("Paste",
                            (e, obj) => e.diagram.commandHandler.pasteSelection(e.diagram.toolManager.contextMenuTool.mouseDownPoint),
                            o => o.diagram.commandHandler.canPasteSelection(o.diagram.toolManager.contextMenuTool.mouseDownPoint)),
                        makeButton("Undo",
                            (e, obj) => e.diagram.commandHandler.undo(),
                            o => o.diagram.commandHandler.canUndo()),
                        makeButton("Redo",
                            (e, obj) => e.diagram.commandHandler.redo(),
                            o => o.diagram.commandHandler.canRedo())
                    ),
            }
        );
        myDiagram.linkTemplate = $(
            go.Link,
            {
                layerName: "Background",
                routing: go.Link.Orthogonal,
                corner: 15,
                reshapable: true,
                resegmentable: true,
                fromSpot: go.Spot.RightSide,
                toSpot: go.Spot.LeftSide,
            },
            // make sure links come in from the proper direction and go out appropriately
            new go.Binding("fromSpot", "fromSpot", go.Spot.parse),
            new go.Binding("toSpot", "toSpot", go.Spot.parse),
            new go.Binding("points").makeTwoWay(),
            // mark each Shape to get the link geometry with isPanelMain: true
            $(go.Shape, { isPanelMain: true, stroke: linkLineColor, strokeWidth: linkLineWidth,name:"PIPELINE" }),
            // get the default stroke color from the fromNode
            //new go.Binding("stroke", "fromNode", n => go.Brush.lighten((n && Colors[n.data.color]) || "gray")).ofObject(),
            // but use the link's data.color if it is set
            //new go.Binding("stroke", "color", colorFunc)),
            $(go.Shape, {
                isPanelMain: true,
                stroke: linkStrokeColor,
                strokeWidth: linkWidth,
                name: "PIPE",
                strokeDashArray: [20, 40],
            })
        );
        const temps = createTemplates()
        let templmap = new go.Map(); // In TypeScript you could write: new go.Map<string, go.Node>();
        // for each of the node categories, specify which template to use
        templmap.add("svg", temps.svgTemplate);
        templmap.add("picture", temps.pictureTemplate);
        templmap.add("pipeline",temps.pipeTemplate)
        // for the default category, "", use the same template that Diagrams use by default;
        // this just shows the key value as a simple TextBlock
        myDiagram.nodeTemplateMap = templmap;

        setModel(myDiagram);

        return myDiagram;
    };
    const updateAnimation = () => {
        if (animation) animation.stop();
        // Animate the flow in the pipes
        let ani = new go.Animation()
        ani.easing = go.Animation.EaseLinear;
        model.links.each(link => {
            ani.add(link.findObject("PIPE"), "strokeDashOffset", 60, 0)
        });
        // Run indefinitely
        ani.runCount = Infinity;
        ani.start();
        setAnimation(ani)
    }

    const palletPlantInit = () => {
        const $ = go.GraphObject.make; // for conciseness in defining templates
        const pallet = $(go.Palette, {
            //initialAutoScale: go.Diagram.Uniform, // scale to show all of the contents
            maxSelectionCount: 1, // don't allow users to select more than one thing at a time
        });
        const temps = createTemplates()
        let templmap = new go.Map(); // In TypeScript you could write: new go.Map<string, go.Node>();
        // for each of the node categories, specify which template to use
        templmap.add("svg", temps.svgTemplate);
        templmap.add("picture", temps.pictureTemplate);
        templmap.add("pipeline",temps.pipeTemplate)
        pallet.nodeTemplateMap = templmap;


        return pallet;
    };

    const palletPipeInit = () => {
        const temps = createTemplates()
        // Make sure the pipes are ordered by their key in the palette inventory
        const keyCompare = (a, b) =>{
            const at = a.data.key;
            const bt = b.data.key;
            if (at < bt) return -1;
            if (at > bt) return 1;
            return 0;
        }
        const $ = go.GraphObject.make; // for conciseness in defining templates
        const pallet = $(go.Palette, {
            initialScale: 1.2,
            contentAlignment: go.Spot.Center,
            "contextMenuTool.isEnabled": false,
            layout: $(go.GridLayout,
                { cellSize: new go.Size(1, 1), spacing: new go.Size(5, 5), comparer: keyCompare }),
            // initialize the Palette with a few "pipe" nodes
            model: new go.GraphLinksModel({
                copiesArrays: true,
                copiesArrayObjects: true,
                linkFromPortIdProperty: "fid",
                linkToPortIdProperty: "tid",
                nodeDataArray: pipePalletNodeDataArray
            })
        });
        let templmap = new go.Map(); // In TypeScript you could write: new go.Map<string, go.Node>();
        // for each of the node categories, specify which template to use

        templmap.add("pipeline",temps.pipeTemplate)
        pallet.nodeTemplateMap = templmap;
        return pallet
    }
    const updatePortHeight = (node, link, port) => {
        let sideinputs = 0;
        let sideoutputs = 0;
        node.findLinksConnected().each((l) => {
            if (l.toNode === node && l.toSpot === go.Spot.LeftSide) sideinputs++;
            if (l.fromNode === node && l.fromSpot === go.Spot.RightSide)
                sideoutputs++;
        });
        let tot = Math.max(sideinputs, sideoutputs);
        tot = Math.max(1, Math.min(tot, 2));
        port.height = tot * (10 + 2) + 2; // where 10 is the link path's strokeWidth
    };


    const updateData = () => {
        model.startTransaction();
        model.nodes.each(function (node) {
            console.log(data);
            model.model.setDataProperty(node.data, "value", data);
        });
        model.commitTransaction("modified Graduated Panel");
    };

    const saveData = () => {
        //db save
        let smallLinkData = model.model.linkDataArray
        smallLinkData.map(x=>{
            x.points = ''
        })
        let currentData = []
        currentData.push({uiNo:props.item.uiNo,attrName:'bgimg',attrVal:bgimg,attrType:'string'})
        currentData.push({uiNo:props.item.uiNo,attrName:'nodeDataArray',attrVal:JSON.stringify(model.model.nodeDataArray),attrType:'string'})
        currentData.push({uiNo:props.item.uiNo,attrName:'linkDataArray',attrVal:JSON.stringify(smallLinkData),attrType:'string'})
        currentData.push({uiNo:props.item.uiNo,attrName:'canvasHeight',attrVal:canvasHeight,attrType:'string'})
        currentData.push({uiNo:props.item.uiNo,attrName:'linkStrokeColor',attrVal:linkStrokeColor,attrType:'string'})
        currentData.push({uiNo:props.item.uiNo,attrName:'linkWidth',attrVal:linkWidth,attrType:'string'})
        currentData.push({uiNo:props.item.uiNo,attrName:'linkLineColor',attrVal:linkLineColor,attrType:'string'})
        currentData.push({uiNo:props.item.uiNo,attrName:'linkLineWidth',attrVal:linkLineWidth,attrType:'string'})
        //props.save(currentData,props.item.uiNo,props.item.opId)
    };
    const handleModelChange = (e) =>{
        if(model){
            updateAnimation()
            model.zoomToFit()
            model.links.each(link => {
                let shape = link.findObject("PIPE");
                shape.stroke = linkStrokeColor
                shape.strokeWidth = linkWidth
                let shape2 = link.findObject("PIPELINE");
                shape2.stroke = linkLineColor
                shape2.strokeWidth = linkLineWidth
            });
        }
    }
    //edit mode
    const display = () => {
        // gojs logo 처리
        // const canvas = document.getElementsByClassName("main")[0].firstChild
        // const context = canvas.getContext('2d');
        // context.clearRect(0, 0, 180, 70);
        // context.save()
        model.isEnabled=!model.isEnabled
        let status = !modelEnable
        setModelEnable(status)

    }
    const handlePipeChange = (e) => {
        if(model) model.clear()
        setSelectedPipe(e.target.value)
        FxmsData.GET('feFacPipe/ui/'+e.target.value).then(res=>{
            let data = res.data
            data.uiDiagLinkList.map(x=>{
                x.from = x.linkDiagNodeNo1
                x.to = x.linkDiagNodeNo2
                x.key = x.diagNodeNo
            })
            data.uiDiagNodeList.map(x=>{
                x.icon = "pyrolysis"
                x.text = x.diagNodeKey
                x.color = "lightgreen"
                x.type = "building"
                x.moNo = ""
                x.category = "svg"
                x.value = ""
                x.key = x.diagNodeNo
                x.pos = "" + x.diagNodeX + " " + x.diagNodeY
            })
            //{"icon":"polymerization","text":"Polymers","color":"lightgreen","type":"building","moNo":999999,"category":"svg","value":11,"key":-6,"pos":"-497.5286865234375 145.10809326171875","__gohashid":23825}
            setNodeData(data.uiDiagNodeList)
            setLinkData(data.uiDiagLinkList)
            // setFeFacDiag(data.feFacDiag)

        })
        // let data = pipeList.filter(x=>x._id == e.target.value)[0]
        // setBgimg(data.bgimg ? 'none':data.bgimg)
        // setCanvasHeight(data.canvasHeight)
        // setLinkStrokeColor(data.linkStrokeColor ? data.linkStrokeColor : "#000000")
        // setLinkWidth(data.linkWidth ?data.linkWidth : 10)
        // setLinkLineColor(data.linkLineColor ? data.linkLineColor : "#707070")
        // setLinkLineWidth(data.lineWidth ? data.lineWidth  : 10)
        // setNodeData(data.nodeDataArray ? data.nodeDataArray : [] )
        // setLinkData(data.linkDataArray ? data.linkDataArray : [])
        let currentData = []
        currentData.push({uiNo:props.item.uiNo,attrName:'pipeId',attrVal:e.target.value,attrType:'string'})
        props.save(currentData,props.item.uiNo,props.item.opId)
    }
    const handleHeightChange = (e) => {
        setCanvasHeight(e.target.value)
    }
    const handleLinkColor = (e) => {
        setLinkStrokeColor(e.target.value)
        model.links.each(link => {
            let shape = link.findObject("PIPE");
            shape.stroke = e.target.value
        });
    }
    const handleLinkWidth = (e) => {
        setLinkWidth(e.target.value)
        model.links.each(link => {
            let shape = link.findObject("PIPE");
            shape.strokeWidth = e.target.value
        });
    }
    const handleLinkLineColor = (e) => {
        setLinkLineColor(e.target.value)
        model.links.each(link => {
            let shape = link.findObject("PIPELINE");
            shape.stroke = e.target.value
        });
    }
    const handleLinkLineWidth = (e) => {
        setLinkLineWidth(e.target.value)
        model.links.each(link => {
            let shape = link.findObject("PIPELINE");
            shape.strokeWidth = e.target.value
        });
    }
    const removeItem = () => {
        props.removeItem(props.item.uiNo)
    }
    return (
        <StyledEngineProvider injectFirst>
            <div>
                <div>
                    {props.editable ?
                        <>
                            {/*<Button variant={"contained"} onClick={saveData} style={{ margin: "10px" }}>save</Button>*/}
                            {/*<Button variant={"contained"} onClick={display} style={{ margin: "10px" }}>{modelEnable?'edit':'disp'}</Button>*/}
                            {/*<TextField sx={{input:{color:'white'},width:'100px', margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*    '.MuiSvgIcon-root ': {fill: "white !important",}}} label={"canvas size"} variant={"outlined"} onChange={handleHeightChange} defaultValue={300}></TextField>*/}
                            {/*<FormControl style={{ margin: "10px" }} size={"small"}>*/}
                            {/*    <InputLabel >배경그림</InputLabel>*/}
                            {/*    <Select*/}
                            {/*        sx={{color: "white", '.MuiOutlinedInput-notchedOutline': {color:'white',borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*            '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*            '.MuiSvgIcon-root ': {fill: "white !important",}*/}
                            {/*        }}*/}
                            {/*        label={"kldsjkl"}*/}
                            {/*        value={bgimg}*/}
                            {/*        onChange={(e) => setBgimg(e.target.value)}*/}
                            {/*        placeholder={"이미지선택"}*/}
                            {/*    >*/}
                            {/*        <MenuItem sx={{color:'white'}} value={"none"}>*/}
                            {/*            {"없음"}*/}
                            {/*        </MenuItem>*/}
                            {/*        <MenuItem sx={{color:'white'}} value={"flarestack_bg.jpg"}>*/}
                            {/*            {"flarestack_bg.jpg"}*/}
                            {/*        </MenuItem>*/}
                            {/*        <MenuItem sx={{color:'white'}} value={"dashboard_guide.png"}>*/}
                            {/*            {"dashboard_guide.png"}*/}
                            {/*        </MenuItem>*/}
                            {/*        <MenuItem sx={{color:'white'}} value={"things.png"}>{"things.png"}</MenuItem>*/}
                            {/*    </Select>*/}
                            {/*</FormControl>*/}
                            <FormControl style={{ margin: "10px" }} size={"small"}>
                                <InputLabel >배관선택</InputLabel>
                                <Select
                                    sx={{color: "white", '.MuiOutlinedInput-notchedOutline': {color:'white',borderColor: 'rgba(243,232,248,0.82)',},
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                        '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                        '.MuiSvgIcon-root ': {fill: "white !important",}
                                    }}
                                    label={"배관선택"}
                                    value={selectedPipe}
                                    onChange={handlePipeChange}
                                    placeholder={"배관선택"}
                                >
                                    {pipeList.map(x=>{
                                        return (
                                            <MenuItem key={x.pipeId} sx={{color:'white'}} value={x.pipeId}>
                                                {x.pipeName+' : '+x.pipeDescr}
                                            </MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                            {/*<TextField sx={{input:{color:'white'},width:'100px', margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*    '.MuiSvgIcon-root ': {fill: "white !important",}}} label={"dash color"} type="color" value={linkStrokeColor} onChange={handleLinkColor}   />*/}
                            {/*<TextField sx={{input:{color:'white'},width:'100px', margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*    '.MuiSvgIcon-root ': {fill: "white !important",}}} label={"dash size"} variant={"outlined"} onChange={handleLinkWidth} defaultValue={linkWidth} ></TextField>*/}
                            {/*<TextField sx={{input:{color:'white'},width:'100px', margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*    '.MuiSvgIcon-root ': {fill: "white !important",}}} label={"line color"} type="color" value={linkLineColor} onChange={handleLinkLineColor} />*/}
                            {/*<TextField sx={{input:{color:'white'},width:'100px', margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},*/}
                            {/*    '.MuiSvgIcon-root ': {fill: "white !important",}}} label={"line size"} variant={"outlined"} onChange={handleLinkLineWidth} defaultValue={linkLineWidth} ></TextField>*/}

                        </> : ''}

                </div>

                <ReactDiagram
                    style={{
                        minHeight: canvasHeight+"px",
                        backgroundImage: bgimg=="none"?"none":"url(" + bgimg + ")",
                        backgroundSize: "cover",
                    }}
                    initDiagram={initDiagram}
                    divClassName="main"
                    nodeDataArray={nodeData}
                    linkDataArray={linkData}
                    onModelChange={handleModelChange}
                />

                {/*{props.editable || modelEnable ? <ReactPalette*/}
                {/*    style={{ minHeight: "200px" }}*/}
                {/*    initPalette={palletPlantInit}*/}
                {/*    divClassName="myPaletteDiv"*/}
                {/*    nodeDataArray={nodeDataArray}*/}
                {/*/> : ''}*/}

                {/*{props.editable || modelEnable ? <ReactPalette*/}
                {/*    style={{ minHeight: "200px" }}*/}
                {/*    initPalette={palletPipeInit}*/}
                {/*    divClassName="myPaletteDiv"*/}
                {/*    nodeDataArray={pipePalletNodeDataArray}*/}

                {/*/> : '' }*/}
            </div>
        </StyledEngineProvider>
    );
};

// Define a custom DraggingTool
class SnappingTool extends go.DraggingTool {
    // This predicate checks to see if the ports can snap together.
    // The first letter of the port id should be "U", "F", or "M" to indicate which kinds of port may connect.
    // The second letter of the port id should be a digit to indicate which direction it may connect.
    // The ports also need to not already have any link connections and need to face opposite directions.
    compatiblePorts(p1, p2) {
        // already connected?
        const part1 = p1.part;
        const id1 = p1.portId;
        if (id1 === null || id1 === "") return false;
        if (part1.findLinksConnected(id1).filter(l => l.category === "").count > 0) return false;
        const part2 = p2.part;
        const id2 = p2.portId;
        if (id2 === null || id2 === "") return false;
        if (part2.findLinksConnected(id2).filter(l => l.category === "").count > 0) return false;
        // compatible fittings?
        if ((id1[0] === 'U' && id2[0] === 'U') ||
            (id1[0] === 'F' && id2[0] === 'M') ||
            (id1[0] === 'M' && id2[0] === 'F')) {
            // find their effective sides, after rotation
            const a1 = this.effectiveAngle(id1, part1.angle);
            const a2 = this.effectiveAngle(id2, part2.angle);
            // are they in opposite directions?
            if (a1 - a2 === 180 || a1 - a2 === -180) return true;
        }
        return false;
    }

    // At what angle can a port connect, adjusting for the node's rotation
    effectiveAngle(id, angle) {
        const dir = id[1];
        let a = 0;
        if (dir === '1') a = 45;
        else if (dir === '2') a = 90;
        else if (dir === '3') a = 135;
        else if (dir === '4') a = 180;
        else if (dir === '5') a = 225;
        else if (dir === '6') a = 270;
        else if (dir === '7') a = 315;
        a += angle;
        if (a < 0) a += 360;
        else if (a >= 360) a -= 360;
        return a;
    }

    // Override this method to find the offset such that a moving port can
    // be snapped to be coincident with a compatible stationary port,
    // then move all of the parts by that offset.
    moveParts(parts, offset, check) {
        // when moving an actually copied collection of Parts, use the offset that was calculated during the drag
        if (this._snapOffset && this.isActive && this.diagram.lastInput.up && parts === this.copiedParts) {
            super.moveParts(parts, this._snapOffset, check);
            this._snapOffset = undefined;
            return;
        }

        let commonOffset = offset;

        // find out if any snapping is desired for any Node being dragged
        const sit = parts.iterator;
        while (sit.next()) {
            const node = sit.key;
            if (!(node instanceof go.Node)) continue;
            const info = sit.value;
            const newloc = info.point.copy().add(offset);

            // now calculate snap point for this Node
            const snapoffset = newloc.copy().subtract(node.location);
            let nearbyports = null;
            let closestDistance = 20 * 20;  // don't bother taking sqrt
            let closestPort = null;
            let closestPortPt = null;
            let nodePort = null;
            const mit = node.ports;
            while (mit.next()) {
                const port = mit.value;
                if (node.findLinksConnected(port.portId).filter(l => l.category === "").count > 0) continue;
                const portPt = port.getDocumentPoint(go.Spot.Center);
                portPt.add(snapoffset);  // where it would be without snapping

                if (nearbyports === null) {
                    // this collects the Nodes that intersect with the NODE's bounds,
                    // excluding nodes that are being dragged (i.e. in the PARTS collection)
                    const nearbyparts = this.diagram.findObjectsIn(node.actualBounds,
                        x => x.part,
                        p => !parts.has(p),
                        true);

                    // gather a collection of GraphObjects that are stationary "ports" for this NODE
                    nearbyports = new go.Set(/*go.GraphObject*/);
                    nearbyparts.each(n => {
                        if (n instanceof go.Node) {
                            nearbyports.addAll(n.ports);
                        }
                    });
                }

                const pit = nearbyports.iterator;
                while (pit.next()) {
                    const p = pit.value;
                    if (!this.compatiblePorts(port, p)) continue;
                    const ppt = p.getDocumentPoint(go.Spot.Center);
                    const d = ppt.distanceSquaredPoint(portPt);
                    if (d < closestDistance) {
                        closestDistance = d;
                        closestPort = p;
                        closestPortPt = ppt;
                        nodePort = port;
                    }
                }
            }

            // found something to snap to!
            if (closestPort !== null) {
                // move the node so that the compatible ports coincide
                const noderelpt = nodePort.getDocumentPoint(go.Spot.Center).subtract(node.location);
                const snappt = closestPortPt.copy().subtract(noderelpt);
                // save the offset, to ensure everything moves together
                commonOffset = snappt.subtract(newloc).add(offset);
                // ignore any node.dragComputation function
                // ignore any node.minLocation and node.maxLocation
                break;
            }
        }

        // now do the standard movement with the single (perhaps snapped) offset
        this._snapOffset = commonOffset.copy();  // remember for mouse-up when copying
        super.moveParts(parts, commonOffset, check);
    }

    // Establish links between snapped ports,
    // and remove obsolete links because their ports are no longer coincident.
    doDropOnto(pt, obj) {
        super.doDropOnto(pt, obj);
        // Need to iterate over all of the dropped nodes to see which ports happen to be snapped to stationary ports
        const coll = this.copiedParts || this.draggedParts;
        const it = coll.iterator;
        while (it.next()) {
            const node = it.key;
            if (!(node instanceof go.Node)) continue;
            // connect all snapped ports of this NODE (yes, there might be more than one) with links
            const pit = node.ports;
            while (pit.next()) {
                const port = pit.value;
                // maybe add a link -- see if the port is at another port that is compatible
                const portPt = port.getDocumentPoint(go.Spot.Center);
                if (!portPt.isReal()) continue;
                const nearbyports =
                    this.diagram.findObjectsAt(portPt,
                        x => {  // some GraphObject at portPt
                            let o = x;
                            // walk up the chain of panels
                            while (o !== null && o.portId === null) o = o.panel;
                            return o;
                        },
                        p => {  // a "port" Panel
                            // the parent Node must not be in the dragged collection, and
                            // this port P must be compatible with the NODE's PORT
                            if (coll.has(p.part)) return false;
                            const ppt = p.getDocumentPoint(go.Spot.Center);
                            if (portPt.distanceSquaredPoint(ppt) >= 0.25) return false;
                            return this.compatiblePorts(port, p);
                        });
                // did we find a compatible port?
                const np = nearbyports.first();
                if (np !== null) {
                    // connect the NODE's PORT with the other port found at the same point
                    this.diagram.toolManager.linkingTool.insertLink(node, port, np.part, np);
                }
            }
        }
    }

    // Just move selected nodes when SHIFT moving, causing nodes to be unsnapped.
    // When SHIFTing, must disconnect all links that connect with nodes not being dragged.
    // Without SHIFT, move all nodes that are snapped to selected nodes, even indirectly.
    computeEffectiveCollection(parts) {
        if (this.diagram.lastInput.shift) {
            const links = new go.Set(/*go.Link*/);
            const coll = super.computeEffectiveCollection(parts);
            coll.iteratorKeys.each(node => {
                // disconnect all links of this node that connect with stationary node
                if (!(node instanceof go.Node)) return;
                node.findLinksConnected().each(link => {
                    if (link.category !== "") return;
                    // see if this link connects with a node that is being dragged
                    const othernode = link.getOtherNode(node);
                    if (othernode !== null && !coll.has(othernode)) {
                        links.add(link);  // remember for later deletion
                    }
                });
            });
            // outside of nested loops we can actually delete the links
            links.each(l => l.diagram.remove(l));
            return coll;
        } else {
            const map = new go.Map(/*go.Part, Object*/);
            if (parts === null) return map;
            parts.iterator.each(n => this.gatherConnecteds(map, n));
            return map;
        }
    }

    // Find other attached nodes.
    gatherConnecteds(map, node) {
        if (!(node instanceof go.Node)) return;
        if (map.has(node)) return;
        // record the original Node location, for relative positioning and for cancellation
        map.add(node, new go.DraggingInfo(node.location));
        // now recursively collect all connected Nodes and the Links to them
        node.findLinksConnected().each(link => {
            if (link.category !== "") return;  // ignore comment links
            map.add(link, new go.DraggingInfo());
            this.gatherConnecteds(map, link.getOtherNode(node));
        });
    }
}
// end SnappingTool class